/**
 * Builds input section props from chat view state and handlers.
 */

import type { InputDisabledConfig } from './chat-content-input.helper'
import type { ChatViewHandlers, ChatViewState } from './chat-view-state.helper'

export const buildInputSectionProps = (
  state: ChatViewState,
  handlers: ChatViewHandlers,
  inputConfig: InputDisabledConfig
) => ({
  value: state.inputValue,
  onChange: handlers.setInputValue,
  mode: state.inputMode,
  onModeChange: handlers.setInputMode,
  attachmentList: state.attachmentList,
  onAttachmentRemove: handlers.handleRemoveAttachment,
  onFilesSelected: handlers.handleFilesSelected,
  onAttachFromChats: handlers.handleAttachFromChats,
  onSend: handlers.handleSend,
  isLoading: state.isLoading || state.isSending,
  isStreaming: state.isStreaming,
  isStopping: state.isStopping,
  onStop: handlers.handleStop,
  isDisabled: inputConfig.isDisabled,
  isFileAttachEnabled: state.isFileAttachEnabled,
  isUploading: state.isUploading,
  uploadProgress: state.uploadProgress,
  placeholder: inputConfig.placeholder,
  templateList: state.templateList,
  onTemplateSelect: handlers.handleTemplateSelect,
  onCreateTemplate: handlers.handleCreateTemplate,
  selectedTemplate: state.selectedTemplate,
  isTemplateFillOpen: state.isTemplateFillOpen,
  templateFillVariableList: state.templateFillVariableList,
  onTemplateFillSubmit: handlers.handleTemplateFillSubmit,
  onTemplateFillCancel: handlers.handleTemplateFillCancel,
})
